<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container>
      <legend>Historia clínica de emergencia</legend>

      {{ $refs.infoPaciente }}

      <HistoriaEmergencia :idPacienteProp="idPaciente" :idClinicaProp="idClinica"/>
    </b-container>
  </div>
</template>

<script>
import HistoriaEmergencia from "@/views/perfilPacientes/historialClinica/HistorialEmergencia";
export default {
  name: "HistorialEmergenciaLink",
  components: {HistoriaEmergencia},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: null,
    idClinica: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente = Number(this.$route.params.idPaciente);
    this.idClinica = Number(this.$route.params.idClinica);
  },
}
</script>

<style scoped>

</style>
